var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWorld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM21 12C21 11.3126 20.9229 10.6432 20.777 10H16.901C16.9652 10.6326 17 11.2993 17 12.0003C17 12.7012 16.9652 13.3676 16.9011 14H20.777C20.9229 13.3568 21 12.6874 21 12ZM14.8901 14H9.10991C9.03926 13.3774 9 12.7113 9 12.0003C9 11.2891 9.03928 10.6228 9.10999 10H14.89C14.9607 10.6228 15 11.2891 15 12.0003C15 12.7113 14.9607 13.3774 14.8901 14ZM16.5822 8H20.0645C18.9831 5.82395 17.0469 4.14766 14.6952 3.41051C15.4523 4.55021 16.1563 6.07435 16.5822 8ZM12 3.27122C12.7931 4.02098 13.9043 5.55094 14.5278 8H9.47222C10.0957 5.55094 11.2069 4.02098 12 3.27122ZM14.528 16C13.9046 18.4495 12.7932 19.9796 12 20.7295C11.2068 19.9796 10.0954 18.4495 9.47205 16H14.528ZM14.6957 20.5893C15.4527 19.4496 16.1566 17.9255 16.5823 16H20.0645C18.9832 18.1759 17.0472 19.8521 14.6957 20.5893ZM7 12.0003C7 11.2993 7.0348 10.6326 7.09896 10H3.22302C3.07706 10.6432 3 11.3126 3 12C3 12.6874 3.07706 13.3568 3.22302 14H7.09889C7.03478 13.3676 7 12.7012 7 12.0003ZM7.4178 8C7.8437 6.07435 8.54775 4.55021 9.30483 3.41051C6.95315 4.14766 5.01692 5.82395 3.93552 8H7.4178ZM3.93552 16H7.41765C7.84342 17.9255 8.5473 19.4496 9.30425 20.5893C6.95283 19.8521 5.01684 18.1759 3.93552 16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWorld);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconWorld.6f6f4f1092284c8e655e28492847eb7d.svg";